import detailPageStyle from 'component/detailPageStyle'
import CustomTooltip from 'component/material/CustomTooltip'
import GridContainer from 'component/material/GridContainer'
import GridItem from 'component/material/GridItem'
import PrimaryButton from 'component/material/PrimaryButton'
import {cs, enGB, sk} from 'date-fns/locale'
import {DB_DATE_FORMAT} from 'helper/constants'
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import DatePicker from 'react-datepicker'
import {connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import {getSupUnavailabilities, putSupUnavailabilities} from 'redux/action/cfsAction'
import {Trans} from '@lingui/macro'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import withStyles from '@material-ui/core/styles/withStyles'

const AvailabilityCalendar = (props) => {
  const {
    getSupUnavailabilities,
    putSupUnavailabilities,
    supplierUnavaLoading,
    supplierUnava,
    onClose,
    globalSettings,
  } = props

  const [unavDates, setUnavDates] = useState([])

  const handleSelectDate = (date) => {
    const unavailable = unavDates?.includes(date)
    if (unavailable) {
      setUnavDates((prevState) => [...prevState.filter((d) => d !== date)])
    } else {
      setUnavDates((prevState) => [...prevState, date])
    }
  }

  const renderDayContents = (day, date) => {
    const formattedDate = moment(date).format(DB_DATE_FORMAT)
    const unavailable = unavDates?.includes(formattedDate)
    return (
      <span
        style={{
          backgroundColor: unavailable ? '#ff000020' : 'initial',
          borderRadius: 4,
          color: unavailable ? 'red' : 'inherit',
          display: 'block',
          fontSize: 15,
        }}
      >
        {day}
      </span>
    )
  }

  const handleSaveDates = () => {
    const data = unavDates?.map((d) => ({date: d}))
    putSupUnavailabilities({unavailabilities: data})
      .then(() => {
        onClose()
      })
      .catch(() => {})
  }

  // TODO: add rest of locales with other translations
  const getLocaleLanguage = (lang) => {
    if (lang === 'cs') {
      return cs
    } else if (lang === 'sk') {
      return sk
    }
    return enGB
  }

  const loadingBoxStyle = {
    width: 'calc(100% + 8px)',
    marginLeft: '-4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    zIndex: 1,
    backdropFilter: 'blur(2px)',
  }

  useEffect(() => {
    if (!supplierUnavaLoading && supplierUnava?.length) {
      setUnavDates(supplierUnava.map((d) => d.date))
    }
  }, [supplierUnava, supplierUnavaLoading])

  useEffect(() => {
    getSupUnavailabilities().catch(() => {})
  }, [])

  return (
    <GridContainer>
      <GridItem xs={12} style={{position: 'relative'}}>
        {supplierUnavaLoading && (
          <Box style={loadingBoxStyle}>
            <CircularProgress />
          </Box>
        )}
        <DatePicker
          inline
          locale={getLocaleLanguage(globalSettings.currentLanguage)}
          calendarStartDay={1}
          shouldCloseOnSelect={false}
          minDate={new Date()}
          renderDayContents={renderDayContents}
          onSelect={(date) => handleSelectDate(moment(date).format(DB_DATE_FORMAT))}
          monthsShown={2}
          dayClassName={() => 'calendar-day-class'}
        />
        <Box style={{display: 'flex', paddingTop: 14, justifyContent: 'flex-end', gap: 16}}>
          <CustomTooltip title={<Trans>Reset to last saved value</Trans>}>
            <PrimaryButton
              onClick={() => setUnavDates(supplierUnava?.map((d) => d.date))}
              variant={'outlined'}
              size={'small'}
              fullWidth={false}
              text={<Trans>Reset</Trans>}
            />
          </CustomTooltip>
          <PrimaryButton
            onClick={handleSaveDates}
            variant={'contained'}
            size={'small'}
            fullWidth={false}
            text={<Trans>Save</Trans>}
          />
        </Box>
      </GridItem>
    </GridContainer>
  )
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getSupUnavailabilities,
      putSupUnavailabilities,
    },
    dispatch
  )
}

export default compose(
  withStyles(detailPageStyle),
  connect((store) => {
    return {
      supplierUnavaLoading: store.cfs.supplierUnavaLoading,
      supplierUnava: store.cfs.supplierUnava,
      globalSettings: store.globalSettings,
    }
  }, mapDispatchToProps)
)(AvailabilityCalendar)
